exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-form-vertical .mm-form-field{margin-bottom:15px}@media (max-width:700px){.mm-dialog--built-in .mm-modal-content{width:85%}}.layout-menubar .menu-item.active{color:#0884f3;background:#f4f9fd}.xm-icon{width:1em;height:1em;margin-right:.8em;vertical-align:-.15em;fill:currentColor;overflow:hidden}", ""]);

// exports
